import Animation from './Animation';
import { play } from '../../../SoundManager';

export default class Blink extends Animation {

	constructor (master) {

		super(master, 0);
		this.loadAudio("blink");
	}

	run () {

	}
}